import { useEffect, useRef } from "react";
import { useFormContext } from "react-hook-form";

import { QuoteRequestLineFormData } from "#modules/quoteRequestLines/types/QuoteRequestLineFormData";
import { useUpdateQuoteRequestLine } from "#modules/quoteRequestLines/view/useUpdateQuoteRequestLine";
import { TextareaController } from "#shared/view/components/TextareaController";

type DetailsPanelCommentProps = {
  label: string;
  accessor: "comment" | "internalComment";
  quoteRequestLineId: string;
};

export const DetailsPanelComment = ({
  label,
  accessor,
  quoteRequestLineId,
}: DetailsPanelCommentProps) => {
  const { control, getValues } = useFormContext<QuoteRequestLineFormData>();
  const lastSavedCommentRef = useRef<string | undefined>(undefined);

  const { updateQuoteRequestLine } = useUpdateQuoteRequestLine({
    quoteRequestId: undefined,
    onSuccess(data) {
      lastSavedCommentRef.current = data[accessor] || undefined;
    },
  });

  useEffect(() => {
    lastSavedCommentRef.current = getValues(accessor); // Checker
  }, [getValues, accessor]);

  const saveComment = (e: React.FocusEvent<HTMLTextAreaElement>) => {
    if (!quoteRequestLineId) {
      return;
    }

    const newComment = e.target.value;
    const prevComment = lastSavedCommentRef.current ?? "";

    if (prevComment === newComment) {
      return;
    }

    updateQuoteRequestLine({
      id: quoteRequestLineId,
      payload: { [accessor]: newComment },
    });
  };

  return (
    <TextareaController
      control={control}
      label={label}
      autosize
      minRows={3}
      name={accessor}
      onBlur={saveComment}
    />
  );
};
